<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>
              {{ `${this.$t("expense.view.title")}` }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="mr-3" color="secondary" :to="'/societyadmin/expense/edit/'+expense.id" >
              <v-icon small left>
                mdi-pencil
              </v-icon>
              Edit
            </v-btn>
            <v-btn class="primary" @click="$router.go(-1)">
              <v-icon left> mdi-chevron-double-left </v-icon>
              {{ `${this.$t("expense.view.buttons.back")}` }}
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-10 text--primary">
            <v-form>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="12">
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("expense.view.headers.title")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="8" md="9">
                      {{ expense.title }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("expense.view.headers.amount")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="6" md="9">
                      ₹ {{ expense.amount }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("expense.view.headers.date")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="6" md="9">
                      {{ getFormattedDate(expense.date) }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold "
                        >{{
                          `${this.$t("expense.view.headers.description")}`
                        }}
                        :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="6" md="9" class="pre-formatted text-wrap">
                      {{ expense.note }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold "
                        >{{
                          `${this.$t("expense.view.headers.category")}`
                        }}
                        :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="6" md="9" class="pre-formatted text-wrap">
                      {{ getCategory() }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold  text-capitalize"
                        >{{ `${this.$t("expense.view.headers.document")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="8" md="9">
                      <v-row>
                        <v-col
                          v-for="item in added_documents"
                          :key="item.document_url"
                          class="d-flex child-flex"
                          cols="3"
                        >
                          <v-card>
                            <v-img
                              v-if="item.file_type == 'image'"
                              :src="API_BASE_URL + '/uploads/' + item.document_url"
                              :lazy-src="
                                API_BASE_URL + '/uploads/' + item.document_url
                              "
                              aspect-ratio="1"
                              class="grey lighten-2"
                            >
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height ma-0"
                                  align="center"
                                  justify="center"
                                >
                                  <v-progress-circular
                                    indeterminate
                                    color="grey lighten-5"
                                  ></v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                            <v-img
                              v-else
                              :src="API_BASE_URL + '/default-pdf.png'"
                              :lazy-src="API_BASE_URL + '/default-pdf.png'"
                              aspect-ratio="1"
                              class="grey lighten-2"
                            >
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height ma-0"
                                  align="center"
                                  justify="center"
                                >
                                  <v-progress-circular
                                    indeterminate
                                    color="grey lighten-5"
                                  ></v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                            <v-btn
                              icon
                              color="secondary"
                              name="view_notice"
                              title="Edit "
                              @click="imgClick(item)"
                              style="float: right"
                            >
                              <v-icon small v-if="item.file_type == 'image'">
                                mdi-eye</v-icon
                              >
                              <v-icon small v-else> mdi-eye</v-icon>
                            </v-btn>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
        <v-dialog v-model="imageDialog">
          <v-card>
            <v-btn
              icon
              color="secondary"
              name="delete_notice"
              title="Edit Notice"
              @click="imageDialog = false"
              style="float: right"
            >
              <v-icon small> mdi-close </v-icon>
            </v-btn>
            <v-card-title class="text-h5 grey lighten-2">
              <v-img
                :src="API_BASE_URL + '/uploads/' + image_url"
                :lazy-src="API_BASE_URL + '/uploads/' + image_url"
                aspect-ratio="1"
                class="grey lighten-2"
              ></v-img>
            </v-card-title>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      user: {},
      loading: false,
      serverSideErrors: {},
      expense: {
        title: "",
        description: "",
      },
      added_documents: [],
      base_url: process.env.VUE_APP_API_URL,
      imageDialog: false,
      image_url: "",
    };
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getExpenseDetail() {
      let _self = this;
      _self.$axios
        .get("societyadmin/expenses/" + _self.$route.params.id)
        .then((response) => {
          let data = response.data;

          console.log(data);
          if (data.status) {
            _self.expense = data.expense;
            _self.added_documents = data.expense.documents;
          } else {
            if (data.errors) {
              _self.serverSideErrors = {};

              for (let i = 0; i < data.errors.length; i++) {
                _self.serverSideErrors[data.errors[i].field] =
                  data.errors[i].message;
              }
            } else {
              this.setAlert({
                showAlert: true,
                variant: "red accent-3",
                timeout: "2000",
                message: data.message,
              });
            }
          }
        });
    },
    imgClick(item) {
      // if (item.file_type == "image") {
      //   this.image_url = item.document_url;
      //   this.imageDialog = true;
      // } else {
      window.open(`${this.base_url}/uploads/${item.document_url}`, "_blank");
      // }
    },
    getFormattedDate(date) {
      return date ? moment(date).format("DD-MM-YYYY hh:mm A") : "N/A";
    },
    getCategory() {
      return this.expense?.category?.name;
    }
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getExpenseDetail();
  },
};
</script>
<style scoped>
.font-30 {
  font-size: 30px !important;
}
/* make the icon clickable in badge slot */
.edit-icon {
  z-index: 1000;
}
.pre-formatted {
  white-space: pre-line !important;

}
</style>